import createIcon from '../../createIcon';

/**
 * @component @name WifiChannel
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYgM0MxMy40OSAzIDEyLjIzIDguNjEgMTEuNiAxMy41N0MxMC43OSAxMC42NiA5LjYxIDggOCA4QzQuNDMgOCAzIDIxIDMgMjFINS4wMUM1LjYyIDE1LjczIDcuMDEgMTEuMTggOCAxMC4xM0M4Ljk4IDExLjE4IDEwLjM4IDE1Ljc0IDEwLjk5IDIxSDEzQzEzLjUgMTguNDcgMTUgMTUgMTYgMTVDMTcgMTUgMTguNSAxOC41MyAxOSAyMUgyMUMyMSAyMSAyMC41IDMgMTYgM1pNMTYgMTNDMTUuMDEgMTMgMTQuMTggMTMuNjIgMTMuNSAxNC41QzE0LjA3IDkuNzMgMTUuMDQgNS44OCAxNiA1LjA2QzE2Ljk3IDUuODcgMTcuOTEgOS43MyAxOC40OSAxNC40OUMxNy44MSAxMy42MiAxNi45OCAxMyAxNiAxM1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const WifiChannel = createIcon('WifiChannel', [
  [
    'path',
    {
      d: 'M16 3C13.49 3 12.23 8.61 11.6 13.57C10.79 10.66 9.61 8 8 8C4.43 8 3 21 3 21H5.01C5.62 15.73 7.01 11.18 8 10.13C8.98 11.18 10.38 15.74 10.99 21H13C13.5 18.47 15 15 16 15C17 15 18.5 18.53 19 21H21C21 21 20.5 3 16 3ZM16 13C15.01 13 14.18 13.62 13.5 14.5C14.07 9.73 15.04 5.88 16 5.06C16.97 5.87 17.91 9.73 18.49 14.49C17.81 13.62 16.98 13 16 13Z',
      key: 'cy04xe',
    },
  ],
]);

export default WifiChannel;
